<template>
	<div>
		<a-upload :action="url" :headers="headers" :name="data.name" :remove="removeFile" :multiple="true" @preview="previewFile"
		 :data="upInfo" method="post" :beforeUpload="beforeUpload" @change="handleChange">
			<a-button>
				<a-icon type="upload" /> 上传文件 </a-button>
		</a-upload>
		<span style="color: red;">上传的附件若含有敏感信息请自行加密后再上传</span>
	</div>
</template>
<script>
	import {
		ACCESS_TOKEN
	} from '@/store/mutation-types'
	import storage from 'store'
	import {
		file_del_java
	} from '@/api/activiti'
	export default {
		data() {
			return {
				headers: {},
				upInfo: null,
				fileList: [],
				url: process.env.VUE_APP_API_BASE_URL + "/file/file/upload"
			}
		},
		props: {
			data: {
				type: Object,
				default: true,
			},
		},
		watch: {
			data(val, old) {
				console.log(val, old)
			},
		},
		methods: {
			//删除文件
			removeFile(file) {
				let data = file.response.data + ',' + file.name
				this.fileList.forEach((item, idx) => {
					if (item == data) {
						this.fileList.splice(idx, 1)
					}
				})
				file_del_java({
					types:this.data.type,
					path:file.response.data.url[0].path
				}).then(res=>{
					this.$message.success('删除成功')
					this.$emit('reduce')
				})
			},
			//预览文件
			previewFile(file) {
				// window.open('https://coa.anliantest.com/oaProxyApi/proxyPython/file/download?path=' + file.response.data)
				window.open(file.response.data.url[0].url)
			},
			// 上传各式限制
			beforeUpload(file) {
				const tok = storage.get(ACCESS_TOKEN)
				this.headers = {
					token: tok,
				}
				this.upInfo = {
					types: this.data.type,
					tempId: this.data.code,
					delFlag: 2,
					path: 'company' + this.$store.state.user.info.deptId + '/',
				}
				var isType = true
				const isLt2M = file.size / 1024 / 1024 < 30
				if (!isLt2M) {
					this.$message.error('上传文件大小不能超过 30MB!')
					this.removeFile(file)
				}
				// if (this.data.types.indexOf(file.type) == -1) {
				// 	isType = false
				// 	this.$message.error('只能上传' + this.data.types.join(',') + '文件')
				// }
				return isLt2M && isType
			},
			//上传文件
			handleChange(info) {
				// info.fileList.forEach((item, idx) => {
				// 	if (this.data.types.indexOf(item.type) == -1) {
				// 		info.fileList.splice(idx, 1)
				// 	}
				// })
				if (info.file.status !== 'uploading') {
					// info.fileList.splice(info.fileList.length - 1, 1)
				}
				if (info.file.status === 'done') {
					if (info.file.response.code != 200) {
						info.fileList.forEach((item, idx) => {
							if (item.uid == info.file.uid) {
								info.fileList.splice(idx, 1)
							}
						})
						this.$message.error(info.file.response.msg)
						return
					}
					this.$message.success('上传成功')
					this.$emit('add')
					this.fileList.push(info.file.response.data.url[0].path)
				} else if (info.file.status === 'error') {
					this.$message.error('上传失败')
				}
			},
		},
	}
</script>
<style>
	.ant-upload-list-item-info {
		color: #00A2FD;
	}
</style>
